export const PRODUCT_RECOMMENDATIONS_FALLBACK = 'fallback';
export const PRODUCT_RECOMMENDATIONS_COMPONENT = 'component';
